import React from 'react';
import { FormikProps } from 'formik';
import ATMLoadingButton from 'src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton';
import ATMTextField from 'src/components/UI/atoms/formFields/ATMTextField/ATMTextField';
import { InquiryLabelsFormValues } from 'src/models/InquiryLabels.model';

type Props = {
    formikProps: FormikProps<InquiryLabelsFormValues>;
    onClose: () => void;
    formType?: "ADD" | "EDIT";
};

const InquiryLabelsForm = ({ formType, formikProps, onClose }: Props) => {
    const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

    return (
        <div className='flex flex-col gap-6 p-4'>
            <div className='flex items-center justify-between'>
                <div className='text-xl font-medium'>{formType === "EDIT" ? "Update Inquiry Label" : "Add Inquiry Label"}</div>
                <button type='button' className='hover:bg-hover' onClick={onClose}>
                    Cancel
                </button>
            </div>
            <div className='flex flex-col gap-4'>
                <div>
                    <ATMTextField
                        name='inquiryLabel'
                        value={values?.inquiryLabel}
                        onChange={(e) => {
                            setFieldValue('inquiryLabel', e.target.value);
                        }}
                        label='Inquiry Label'
                        placeholder='Please Enter Inquiry Label'
                        onBlur={handleBlur}
                    />
                </div>

            </div>
            <div>
                <ATMLoadingButton isLoading={isSubmitting} type='submit'>
                    Save
                </ATMLoadingButton>
            </div>
        </div>
    );
};

export default InquiryLabelsForm;